export default __webpack_public_path__ + "b36f96818d78e8c66261af258a3b1d1c.svg";